import type { FlaggedArea, FlaggedAreaInput, FlaggedAreaListQuery, Page } from '@chukua/common';
import { toListParams } from '../../../../shared/policies/list-params';
import { api } from '../../../../shared/shared.api';

export type { FlaggedArea };

export function listFlaggedAreas(query: FlaggedAreaListQuery): Promise<Page<FlaggedArea>> {
  return api<Page<FlaggedArea>>(`/flagged-areas?${toListParams(query)}`);
}

export function getFlaggedArea(id: string): Promise<FlaggedArea> {
  return api<FlaggedArea>(`/flagged-areas/${id}`);
}

export function createFlaggedArea(input: FlaggedAreaInput): Promise<FlaggedArea> {
  return api<FlaggedArea>('/flagged-areas', { method: 'POST', body: JSON.stringify(input) });
}

export function updateFlaggedArea(id: string, input: FlaggedAreaInput): Promise<FlaggedArea> {
  return api<FlaggedArea>(`/flagged-areas/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateFlaggedArea(id: string): Promise<void> {
  await api<void>(`/flagged-areas/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateFlaggedArea(id: string): Promise<void> {
  await api<void>(`/flagged-areas/${id}/reactivate`, { method: 'POST' });
}
